var __jsx = React.createElement;
import React, { useState, useRef, useCallback, useEffect } from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faChevronLeft, faFileLines } from "@fortawesome/pro-regular-svg-icons";
import ACRSubmissionForm from "./ACRSubmissionForm";
import Button from "../common/Button";
import AllACRSubmissions from "./AllACRSubmissions";
import useGetPatientReports from "./services/useGetPatientReports";
import Loader from "../Loader";
import SubmissionPreviewCard from "./SubmissionPreviewCard";
import { SUBMISSION_STATUS } from "../../constants/acr";
import { useTranslation } from "react-i18next";
var ACRSubmission = function ACRSubmission(_ref) {
  var patientId = _ref.patientId,
    workspaceId = _ref.workspaceId,
    onBackToSummary = _ref.onBackToSummary,
    externalSubmissionToOpen = _ref.externalSubmissionToOpen,
    onExternalSubmissionOpened = _ref.onExternalSubmissionOpened;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    activeSubmissionID = _useState[0],
    setActiveSubmissionID = _useState[1];
  var _useState2 = useState(0),
    reopenTrigger = _useState2[0],
    setReopenTrigger = _useState2[1];
  var _useState3 = useState(false),
    isAllSubmissionModalOpen = _useState3[0],
    setIsAllSubmissionModalOpen = _useState3[1];
  var shouldReopenAllSubmissionsRef = useRef(false);
  var _useState4 = useState(SUBMISSION_STATUS.PENDING),
    activeTab = _useState4[0],
    setActiveTab = _useState4[1];
  var _useGetPatientReports = useGetPatientReports({
      workspaceId: workspaceId,
      patientId: patientId
    }),
    data = _useGetPatientReports.data,
    isLoading = _useGetPatientReports.isLoading;
  var reports = (data === null || data === void 0 ? void 0 : data.results) || [];

  // Filter to only pending/rejected submissions, sort by newest first, limit to 5
  var pendingRejectedReports = reports.filter(function (r) {
    return r.acr_submission && (r.acr_submission.status.toLowerCase() === SUBMISSION_STATUS.PENDING || r.acr_submission.status.toLowerCase() === SUBMISSION_STATUS.REJECTED || r.acr_submission.status.toLowerCase() === SUBMISSION_STATUS.READY);
  }).sort(function (a, b) {
    return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
  }).slice(0, 5);

  // Look up report by submission ID
  var openACRSubmissionForm = function openACRSubmissionForm(id, _isPopulated) {
    var fromAllSubmissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // If clicking the same submission that's already open, increment trigger to force reopen
    if (activeSubmissionID === id) {
      setReopenTrigger(function (prev) {
        return prev + 1;
      });
    } else {
      setActiveSubmissionID(id);
    }
    setIsAllSubmissionModalOpen(false);
    shouldReopenAllSubmissionsRef.current = fromAllSubmissions;
  };
  var handleCloseACRSubmissionForm = function handleCloseACRSubmissionForm() {
    setActiveSubmissionID(null);
    if (shouldReopenAllSubmissionsRef.current) {
      setIsAllSubmissionModalOpen(true);
      shouldReopenAllSubmissionsRef.current = false;
    }
  };
  var handleActiveSubmissionSync = useCallback(function (activeId) {
    setActiveSubmissionID(activeId);
  }, []);
  useEffect(function () {
    if (externalSubmissionToOpen) {
      if (activeSubmissionID === externalSubmissionToOpen) {
        setReopenTrigger(function (prev) {
          return prev + 1;
        });
      } else {
        setActiveSubmissionID(externalSubmissionToOpen);
      }
      onExternalSubmissionOpened === null || onExternalSubmissionOpened === void 0 || onExternalSubmissionOpened();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalSubmissionToOpen]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "large"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full overflow-hidden bg-white dark:bg-gray-900 flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-5 py-[7px] bg-gray-200 dark:bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onBackToSummary,
    className: "hover:bg-gray-100 dark:hover:bg-gray-700 -ml-2 px-2 rounded transition-colors cursor-pointer"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    size: "sm",
    className: "text-gray-800 dark:text-gray-200"
  })), /*#__PURE__*/React.createElement("span", {
    className: "flex-1 ml-3 text-gray-800 dark:text-gray-200 font-medium text-base"
  }, t("label.acr.acr_submissions"))), pendingRejectedReports.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center flex-1 text-gray-600 dark:text-gray-400"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faFileLines,
    size: "lg",
    className: "mb-3"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-base"
  }, t("label.acr.no_pending_submissions"))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 flex flex-col gap-4 "
  }, pendingRejectedReports.map(function (report) {
    return /*#__PURE__*/React.createElement(SubmissionPreviewCard, {
      key: report.report_id,
      report: report,
      onClick: function onClick() {
        return openACRSubmissionForm(report.acr_submission.id, false);
      }
    });
  }), reports.length > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setIsAllSubmissionModalOpen(true);
    }
  }, t("button.view_all_exams"))), isAllSubmissionModalOpen && /*#__PURE__*/React.createElement(AllACRSubmissions, {
    isOpen: isAllSubmissionModalOpen,
    setIsAllSubmissionModalOpen: setIsAllSubmissionModalOpen,
    onSubmissionViewDetails: function onSubmissionViewDetails(id) {
      return openACRSubmissionForm(id, false, true);
    },
    workspaceId: workspaceId,
    patientId: patientId,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  }), activeSubmissionID && /*#__PURE__*/React.createElement(ACRSubmissionForm, {
    isOpen: !!activeSubmissionID,
    submissionID: activeSubmissionID,
    handleClose: handleCloseACRSubmissionForm,
    patientId: patientId,
    workspaceId: workspaceId,
    reopenTrigger: reopenTrigger,
    onActiveSubmissionSync: handleActiveSubmissionSync
  }));
};
export default ACRSubmission;